@if (!isLoading()) {
  <aside>
    <div class="space">
		<button htm-button theme="icon" attr.aria-label="{{ 'button.close' | translate }} {{
			'frontpage.main_menu' | translate
    }}" (click)="closeSidemenu()" #sidemenuCloser>
        <span class="button--label">
          <icon class="large" glyph="x" size="large" aria-hidden="true"></icon>
        </span>
      </button>
    </div>
    @if ((data | async); as data) {
      @if (!data?.length) {
        <div class="loader">
          <loader></loader>
        </div>
      }
      <nav class="sidemenu__wrapper">
        @if (data?.length) {
          <sidemenu-item [items]="data" [type]="'category'" (hideToggle)="hideOthers($event)"></sidemenu-item>
        }
        <div class="sidemenu__separator"></div>
        <language-switcher
          [languageData]="languageService.languageSwitcherData$ | async"
          (languageChangeEvent)="languageService.handleLanguageChange($event)"
          [isInSidemenu]="true"
        ></language-switcher>
      </nav>
    }
    <dark-mode-toggle></dark-mode-toggle>
  </aside>
}
